import { ByteChannel3cxdguezl3lu7 as ByteChannel } from './ByteChannel.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function attachWriterJob(_this__u8e3s4, writerJob) {
  var tmp = writerJob.v4k_1;
  var tmp0_safe_receiver = tmp instanceof ByteChannel() ? tmp : null;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.k4k((cause) => {
      var tmp;
      if (!(cause == null)) {
        _this__u8e3s4.j4k(cause);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  attachWriterJob as attachWriterJob2dr3tee7atoa9,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
